import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_10_16() {
  return (
    <NoteContainer date={'16/10/2025'} version="20.13.0">
      <VStack w="full">
        <ExclusiveContainer category="ADVERTISEMENT" institutions={['teste', 'treinamento', 'agsus']}>
          <VStack w="full">
            <CategoryContainer category="ADVERTISEMENT">
              <Box>
                <TaskTitle important={true}>Retificação das solicitações em que a automação não funcionou</TaskTitle>
                <TaskBreadcrumb>Solicitações de serviços</TaskBreadcrumb>
                <TaskDescription>
                  Foram retificadas várias solicitações do tipo &quot;Admissão&quot; onde existia um erro na automação.
                  Esse erro foi corrigido e todas as solicitações foram retificadas.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ExclusiveContainer>

        <ExclusiveContainer category="ADJUSTMENTS" institutions={['teste', 'treinamento', 'agsus']}>
          <GeneralContainer>
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle important={true}>Consultas de holerite atualizadas</TaskTitle>
                  <TaskBreadcrumb>Geral</TaskBreadcrumb>
                  <TaskDescription>
                    Agora, quando consultar o holerite, será verificado todas as possíveis matriculas cadastradas na
                    base de dados, sendo possível escolher qual delas será utilizada na consulta. Isso vale para os
                    módulos <strong>App Colaborador</strong> e <strong>Perfil Colaborador</strong>
                  </TaskDescription>
                </Box>
              </CategoryContainer>

              <CategoryContainer category="FIX">
                <Box>
                  <TaskTitle important={true}>Erro na geração do holerite</TaskTitle>
                  <TaskBreadcrumb>Geral</TaskBreadcrumb>
                  <TaskDescription>
                    Correção do filtro de consulta do holerite, onde era considerado sempre o mês anterior a consulta
                    feita.
                  </TaskDescription>
                  <TaskDescription>
                    Correção do filtro que impossibilitava a geração do holerite para alguns usuários.
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </GeneralContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="SCHEDULES">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Ajuste na página raíz do módulo</TaskTitle>
                <TaskBreadcrumb>Raíz do módulo</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que deixava a página em branco ao entrar diretamente pela URL raíz do módulo
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="ATTENDANCES">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Erro ao solicitar uma solicitação via atendimento presencial</TaskTitle>
                <TaskBreadcrumb>Atendimento presencial/ perfil do atendimento</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que impossibilitava a solicitação de um serviço via atendimento presencial
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="SERVICES_LETTER">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Carregamento infinito na filtragem de serviços</TaskTitle>
                <TaskBreadcrumb>Serviços</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que deixava a página carregando infinitamente ao filtrar os serviços
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento']}>
          <ModuleContainer moduleName="UNIFIED_LOGIN">
            <VStack w="full">
              <CategoryContainer category="FEATURE">
                <Box>
                  <TaskTitle>Testes automatizados</TaskTitle>
                  <TaskBreadcrumb>Login unificado</TaskBreadcrumb>
                  <TaskDescription>Testes automatizados dos fluxos básicos do login</TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>

        <ModuleContainer moduleName="CITIZEN_PROFILE">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Ajuste no cartão de um arquivo</TaskTitle>
                <TaskBreadcrumb>Pessoas unificadas/ Perfil da pessoa unificada/ arquivos</TaskBreadcrumb>
                <TaskDescription>Ajuste no cartão do arquivo para o nome do mesmo não vazar do cartão</TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Ajuste no tamanho da página</TaskTitle>
                <TaskBreadcrumb>Pessoas unificadas/ Perfil da pessoa unificada</TaskBreadcrumb>
                <TaskDescription>
                  Ajuste no tamanho da página para que ela tenha 100% da altura disponível
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="REGULATION">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Retirado campo de descrição</TaskTitle>
                <TaskBreadcrumb>Regulação/ Painel da regulação</TaskBreadcrumb>
                <TaskDescription>
                  Retirada o campo descrição das informações da solicitação. O campo não será mais utilizado pelos
                  usuários
                </TaskDescription>
              </Box>
            </CategoryContainer>

            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção dos assinantes</TaskTitle>
                <TaskBreadcrumb>Regulação/ Painel da regulação</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro que impedia a visualização correta dos assinantes da solicitação
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
